module.exports = {
      id: "logout-usage",
      viewBox: "0 0 75 28",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#logout",
      toString: function () {
        return this.url;
      }
    }